import { User } from "@auth0/auth0-react";
import { featureService } from "../services/featureService/FeatureService";
import { ryanTransService } from "../services/RyanTransService/RyanTransService";
import { usersService } from "../services/user/UsersService";
import { CURRENT_USER, TOKEN_CACHE } from "./constants";
import { logFirebaseUser } from "./firebaseUtils";

const MERCURYGATE_TOKEN_URL = process.env.REACT_APP_MERCURYGATE_TOKEN_URL || "";
const RTSPRO_URL = process.env.REACT_APP_RTS_PRO_SHELL_URL || "";
const MERCURY_GATE_PERMISSION = "ryantrans.MercuryGateToken";

const setUser = (user: User) => {
  localStorage.setItem(CURRENT_USER, JSON.stringify(user));
};

export const getUserLocalStorage = () => {
  const user = localStorage.getItem(CURRENT_USER);
  return user ? (JSON.parse(user) as User) : null;
};

export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_CACHE);
};

export const authenticateAuth0AndSaveUser = async (email: string) => {
  const { user } = await usersService.getUserByEmail(email);
  logFirebaseUser(user._id, user.user_type);
  setUser(user as User);
};

export const redirectToLogin = () => {
  clearLocalStorageAuth();

  const url = `${RTSPRO_URL}/auth?finaldestination=${encodeURIComponent(
    MERCURYGATE_TOKEN_URL,
  )}`;
  window.location.replace(url);
};

export const redirectToLogout = (auth0Logout?: any) => {
  if (auth0Logout) {
    clearLocalStorageAuth();
    auth0Logout();
  } else {
    clearLocalStorageAuth();
    const redirect = encodeURIComponent(MERCURYGATE_TOKEN_URL);
    window.location.assign(`${RTSPRO_URL}/logout?finaldestination=${redirect}`);
  }
};

export const clearLocalStorageAuth = () => {
  localStorage.removeItem(TOKEN_CACHE);
  localStorage.removeItem(CURRENT_USER);
};

export const isMercuryGateUser = () => {
  const user = getUserLocalStorage();

  return (
    user?.permissions &&
    user.permissions.some((x) => x.name === MERCURY_GATE_PERMISSION)
  );
};

export const addInterceptorsToServices = async (
  isAuth0Enabled: boolean,
  getAccessTokenSilently?: () => Promise<string>,
  logout?: () => Promise<void>,
) => {
  await Promise.all([
    usersService.addInterceptors(
      isAuth0Enabled,
      getAccessTokenSilently,
      logout,
    ),
    featureService.addInterceptors(
      isAuth0Enabled,
      getAccessTokenSilently,
      logout,
    ),
    ryanTransService.addInterceptors(
      isAuth0Enabled,
      getAccessTokenSilently,
      logout,
    ),
  ]);
};
